import React, { memo, useCallback } from 'react';

import { dispatch as CustomDispatch } from 'redux/actions/index';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import tvNavigationColors from './tvNavigationColors';
import { ActionToggleMarkets } from '../../../redux/actions/dashboard';
import { selectIsOpenMarketsSideBar } from '../../../redux/selectors/dashboard';

const useStyle = makeStyles({
  marketSidebarNavigation: {
    position: 'absolute',
    top: 'calc(98% - 40px)',
    background: `${tvNavigationColors.background}`,
    width: 10,
    zIndex: 1,
    right: -10,
    height: 40,
    display: 'inline-block',
    border: `1px solid ${tvNavigationColors.borderColor}`,
    borderLeft: 'none',
    paddingRight: '5px',
    borderRadius: 10,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    cursor: 'pointer',
  },
  arrow: {
    display: 'flex',
    flexDirection: 'column',

    '&:before, &:after': {
      content: '" "',
      width: 3,
      height: 12,
      borderRadius: 5,
      background: '#272727',
      display: 'inline-block',
    },

    '&:before': {
      transform: 'rotate(-12deg)',
      marginBottom: -2,
    },

    '&:after': {
      transform: 'rotate(12deg)',
      marginTop: -2,
    },
    '&$open:before': {
      transform: 'rotate(-168deg)',
      marginBottom: -2,
    },

    '&$open:after': {
      transform: 'rotate(-192deg)',
      marginTop: -2,
    },
  },
  open: {},
  arrowWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'transparent',
    border: 'none',
    width: 5,
  },
});

function MarketSidebarNavigation() {
  const dispatch = useDispatch();
  const classes = useStyle();

  const isOpenMarketsSideBar = useSelector(selectIsOpenMarketsSideBar);

  const handleMarketSidebar = useCallback(() => {
    dispatch(ActionToggleMarkets());
  }, []);

  return (
    <div onClick={handleMarketSidebar}>
      <div
        className={classes.marketSidebarNavigation}
        style={!isOpenMarketsSideBar ? { zIndex: 0, background: '#1976d2', borderColor: '#1976d2' } : { zIndex: 0 }}
      ></div>
      <div className={classes.marketSidebarNavigation + ' ' + classes.arrowWrapper}>
        <div className={classes.arrow + ' ' + (isOpenMarketsSideBar ? classes.open : '')}></div>
      </div>
    </div>
  );
}

export default memo(MarketSidebarNavigation);
